import React, { useRef, useEffect } from "react";
import "./supported-by.css";

const logos = [
  "/images/logo/If-we-build-it-logo.jpg",
  "/images/logo/Kspca-logo.png",
  "/images/logo/KSTVET-logo.png",
  "/images/logo/Radio-44-logo.png",
  "/images/logo/kenyabuzz.webp",
  "/images/logo/mic-jasiri-logo.png",
  "/images/logo/Nomad-logo.jpg"
];

const SupportedBy = () => {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    // measure the width of exactly ONE set of logos (first half of the track)
    // then set the animation to translateX by exactly that amount
    const items = track.querySelectorAll(".logo-item");
    const halfCount = logos.length;
    let halfWidth = 0;
    items.forEach((item, i) => {
      if (i < halfCount) halfWidth += item.offsetWidth;
    });

    track.style.setProperty("--marquee-width", `${halfWidth}px`);
  }, []);

  return (
    <section className="supported-section">
      <h3 className="supported-label">Company We keep</h3>

      <div className="logo-marquee">
        <div className="logo-track" ref={trackRef}>
          {/* original set */}
          {logos.map((logo, i) => (
            <div className="logo-item" key={`a-${i}`}>
              <img src={logo} alt="Partner logo" />
            </div>
          ))}
          {/* exact duplicate — when original scrolls off, this is already in place */}
          {logos.map((logo, i) => (
            <div className="logo-item" key={`b-${i}`}>
              <img src={logo} alt="" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SupportedBy;